// CMVMC / Materials Consumed Data
export const cmvmcCostsData = {
  2024: {
    totalCost: 58.0, 
    weightInOpex: 34.7, 
    yoyChange: 8.5, 
    vsBudget: 4.2,
    costPerTonProcessed: 24.2,
    costPerCarat: 52.7,
    
    // KPIs específicos
    kpis: {
      fuelConsumptionPerHour: { value: 42.5, unit: 'L/h', vsBudget: 3.2, vsLY: 2.1 },
      materialsPerTonProcessed: { value: 24.2, unit: 'USD/t', vsBudget: 4.2, vsLY: 6.8 },
      consumablesPerCarat: { value: 52.7, unit: 'USD/ct', vsBudget: 5.1, vsLY: 8.2 },
      avgUnitPrice: { value: 2.85, unit: 'USD/L', vsBudget: 8.5, vsLY: 12.3 },
      top5MaterialsShare: { value: 78.5, unit: '%', vsBudget: 1.2, vsLY: 2.1 },
    },
    
    // Decomposição por grandes itens
    byCategory: [
      { category: { pt: 'Gasóleo', en: 'Diesel' }, value: 18.5, percentage: 31.9, yoyChange: 12.3, vsBudget: 5.8, unitCost: 2.85, consumption: 6500000 },
      { category: { pt: 'Stock Consignado - Peças Cimertex', en: 'Consigned Stock - Cimertex Parts' }, value: 10.0, percentage: 17.2, yoyChange: 8.5, vsBudget: 3.2, unitCost: null, consumption: null },
      { category: { pt: 'Conservação e Reparação', en: 'Conservation & Repair' }, value: 7.8, percentage: 13.4, yoyChange: 6.5, vsBudget: 2.8, unitCost: null, consumption: null },
      { category: { pt: 'Explosivos', en: 'Explosives' }, value: 6.7, percentage: 11.6, yoyChange: 6.2, vsBudget: 2.1, unitCost: 4.20, consumption: 1595000 },
      { category: { pt: 'Pneus', en: 'Tires' }, value: 4.9, percentage: 8.4, yoyChange: 15.2, vsBudget: 8.2, unitCost: 12500, consumption: 392 },
      { category: { pt: 'Lubrificantes e Outros Fluídos', en: 'Lubricants & Other Fluids' }, value: 4.3, percentage: 7.4, yoyChange: 5.2, vsBudget: 1.8, unitCost: 8.50, consumption: 506000 },
      { category: { pt: 'DMS Ferro Silício', en: 'DMS Ferrosilicon' }, value: 2.7, percentage: 4.7, yoyChange: 12.5, vsBudget: 4.8, unitCost: 1.71, consumption: 1579000 },
      { category: { pt: 'Material Protecção, Seg. e Conforto', en: 'PPE, Safety & Comfort' }, value: 2.3, percentage: 4.0, yoyChange: 3.8, vsBudget: -0.5, unitCost: null, consumption: null },
      { category: { pt: 'Ferrament. e Utensílios Desg. Rápido', en: 'Tools & Fast-Wear Items' }, value: 0.8, percentage: 1.4, yoyChange: 4.2, vsBudget: 0.5, unitCost: null, consumption: null },
    ],
    
    // Dados mensais
    monthlyData: [
      { month: 'Jan', cost: 4.5, budget: 4.3, volume: 195, unitCost: 23.1 },
      { month: 'Feb', cost: 4.6, budget: 4.4, volume: 198, unitCost: 23.2 },
      { month: 'Mar', cost: 4.9, budget: 4.6, volume: 205, unitCost: 23.9 },
      { month: 'Apr', cost: 4.8, budget: 4.5, volume: 200, unitCost: 24.0 },
      { month: 'May', cost: 4.8, budget: 4.5, volume: 198, unitCost: 24.2 },
      { month: 'Jun', cost: 5.0, budget: 4.7, volume: 210, unitCost: 23.8 },
      { month: 'Jul', cost: 4.9, budget: 4.6, volume: 205, unitCost: 23.9 },
      { month: 'Aug', cost: 4.8, budget: 4.5, volume: 202, unitCost: 23.8 },
      { month: 'Sep', cost: 4.7, budget: 4.5, volume: 198, unitCost: 23.7 },
      { month: 'Oct', cost: 4.9, budget: 4.6, volume: 205, unitCost: 23.9 },
      { month: 'Nov', cost: 4.8, budget: 4.5, volume: 200, unitCost: 24.0 },
      { month: 'Dec', cost: 5.3, budget: 4.8, volume: 198, unitCost: 26.8 },
    ],
    
    // Análise Preço vs Volume (Price-Volume Bridge)
    priceVolumeAnalysis: {
      baselineCost: 53.5,
      volumeEffect: { value: 2.8, description: { pt: '+5.2% mais horas de operação', en: '+5.2% more operating hours' } },
      priceEffect: { value: 1.7, description: { pt: '+3.2% aumento preços combustível', en: '+3.2% fuel price increase' } },
      currentCost: 58.0,
    },
    
    // Consumo unitário por atividade
    unitConsumption: [
      { activity: { pt: 'Escavação', en: 'Excavation' }, unit: 'L/m³', current: 0.85, budget: 0.82, ly: 0.80, trend: 'up' },
      { activity: { pt: 'Transporte', en: 'Hauling' }, unit: 'L/t.km', current: 0.052, budget: 0.050, ly: 0.048, trend: 'up' },
      { activity: { pt: 'Processamento', en: 'Processing' }, unit: 'kg/t', current: 2.15, budget: 2.10, ly: 2.05, trend: 'up' },
      { activity: { pt: 'Perfuração', en: 'Drilling' }, unit: 'L/m', current: 3.20, budget: 3.10, ly: 3.05, trend: 'up' },
    ],
    
    // Heatmap de consumo unitário mensal
    monthlyUnitConsumption: [
      { month: 'Jan', fuel: 0.82, explosives: 1.05, reagents: 2.10, lubricants: 0.18 },
      { month: 'Feb', fuel: 0.83, explosives: 1.06, reagents: 2.12, lubricants: 0.18 },
      { month: 'Mar', fuel: 0.85, explosives: 1.08, reagents: 2.15, lubricants: 0.19 },
      { month: 'Apr', fuel: 0.84, explosives: 1.07, reagents: 2.14, lubricants: 0.19 },
      { month: 'May', fuel: 0.85, explosives: 1.08, reagents: 2.15, lubricants: 0.19 },
      { month: 'Jun', fuel: 0.86, explosives: 1.09, reagents: 2.18, lubricants: 0.20 },
      { month: 'Jul', fuel: 0.85, explosives: 1.08, reagents: 2.16, lubricants: 0.19 },
      { month: 'Aug', fuel: 0.84, explosives: 1.07, reagents: 2.14, lubricants: 0.19 },
      { month: 'Sep', fuel: 0.84, explosives: 1.06, reagents: 2.13, lubricants: 0.18 },
      { month: 'Oct', fuel: 0.85, explosives: 1.08, reagents: 2.15, lubricants: 0.19 },
      { month: 'Nov', fuel: 0.85, explosives: 1.07, reagents: 2.14, lubricants: 0.19 },
      { month: 'Dec', fuel: 0.88, explosives: 1.10, reagents: 2.20, lubricants: 0.21 },
    ],
    
    // Waterfall Preço vs Volume
    priceVolumeWaterfall: [
      { name: { pt: 'Custo 2023', en: 'Cost 2023' }, value: 53.5, type: 'start' },
      { name: { pt: 'Efeito Volume', en: 'Volume Effect' }, value: 2.8, type: 'increase', description: { pt: 'Mais horas de operação', en: 'More operating hours' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Volume', en: 'Volume Effect Decomposition' },
          metrics: [
            { label: { pt: 'Horas Operação 2023', en: 'Operating Hours 2023' }, value: '6,200 h', change: null },
            { label: { pt: 'Horas Operação 2024', en: 'Operating Hours 2024' }, value: '6,520 h', change: '+5.2%' },
            { label: { pt: 'Consumo Adicional', en: 'Additional Consumption' }, value: '+320 h', change: null },
            { label: { pt: 'Custo Médio por Hora', en: 'Avg Cost per Hour' }, value: '8.75 USD/h', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+2.8 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Efeito Preço Combustível', en: 'Fuel Price Effect' }, value: 1.2, type: 'increase', description: { pt: 'Aumento preço diesel', en: 'Diesel price increase' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Preço Combustível', en: 'Fuel Price Effect Decomposition' },
          metrics: [
            { label: { pt: 'Preço Médio 2023', en: 'Avg Price 2023' }, value: '2.54 USD/L', change: null },
            { label: { pt: 'Preço Médio 2024', en: 'Avg Price 2024' }, value: '2.85 USD/L', change: '+12.2%' },
            { label: { pt: 'Consumo Associado', en: 'Associated Consumption' }, value: '6.5 M L', change: null },
            { label: { pt: 'Variação de Preço', en: 'Price Variation' }, value: '+0.31 USD/L', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+1.2 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Efeito Preço Explosivos', en: 'Explosives Price Effect' }, value: 0.3, type: 'increase', description: { pt: 'Inflação de materiais', en: 'Materials inflation' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Preço Explosivos', en: 'Explosives Price Effect Decomposition' },
          metrics: [
            { label: { pt: 'Preço Médio 2023', en: 'Avg Price 2023' }, value: '4.08 USD/kg', change: null },
            { label: { pt: 'Preço Médio 2024', en: 'Avg Price 2024' }, value: '4.20 USD/kg', change: '+2.9%' },
            { label: { pt: 'Consumo Associado', en: 'Associated Consumption' }, value: '2.9 M kg', change: null },
            { label: { pt: 'Variação de Preço', en: 'Price Variation' }, value: '+0.12 USD/kg', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+0.3 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Eficiência Consumo', en: 'Consumption Efficiency' }, value: -0.5, type: 'decrease', description: { pt: 'Melhor gestão de frota', en: 'Better fleet management' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Eficiência', en: 'Efficiency Effect Decomposition' },
          metrics: [
            { label: { pt: 'Consumo Combustível/h 2023', en: 'Fuel Consumption/h 2023' }, value: '43.8 L/h', change: null },
            { label: { pt: 'Consumo Combustível/h 2024', en: 'Fuel Consumption/h 2024' }, value: '42.5 L/h', change: '-3.0%' },
            { label: { pt: 'Melhorias Implementadas', en: 'Improvements Implemented' }, value: '8 equipamentos', change: null },
            { label: { pt: 'Poupança Unitária', en: 'Unit Savings' }, value: '-1.3 L/h', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '-0.5 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Mix de Materiais', en: 'Materials Mix' }, value: 0.7, type: 'increase', description: { pt: 'Maior uso de reagentes', en: 'Higher reagent use' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Mix de Materiais', en: 'Materials Mix Effect Decomposition' },
          metrics: [
            { label: { pt: 'Reagentes/ton 2023', en: 'Reagents/ton 2023' }, value: '2.05 kg/t', change: null },
            { label: { pt: 'Reagentes/ton 2024', en: 'Reagents/ton 2024' }, value: '2.15 kg/t', change: '+4.9%' },
            { label: { pt: 'Toneladas Processadas', en: 'Tons Processed' }, value: '2.4 Mt', change: null },
            { label: { pt: 'Consumo Adicional', en: 'Additional Consumption' }, value: '+240 t reagentes', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+0.7 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Custo 2024', en: 'Cost 2024' }, value: 58.0, type: 'end' },
    ],
    
    // Drivers chave
    keyDrivers: [
      { driver: { pt: 'Horas de Operação', en: 'Operating Hours' }, impact: 'high', direction: 'up', detail: { pt: '+5.2% mais horas aumentou consumo de combustível proporcionalmente', en: '+5.2% more hours increased fuel consumption proportionally' } },
      { driver: { pt: 'Preço do Diesel', en: 'Diesel Price' }, impact: 'high', direction: 'up', detail: { pt: 'Aumento de 12.3% no preço médio do diesel', en: '12.3% increase in average diesel price' } },
      { driver: { pt: 'Eficiência da Frota', en: 'Fleet Efficiency' }, impact: 'medium', direction: 'down', detail: { pt: 'Envelhecimento da frota aumentou consumo unitário em 3.2%', en: 'Fleet aging increased unit consumption by 3.2%' } },
      { driver: { pt: 'Throughput da Planta', en: 'Plant Throughput' }, impact: 'medium', direction: 'up', detail: { pt: 'Maior throughput aumentou consumo de reagentes', en: 'Higher throughput increased reagent consumption' } },
    ],
  },
  2025: {
    totalCost: 64.6, 
    weightInOpex: 33.0, 
    yoyChange: 11.4, 
    vsBudget: 3.5,
    costPerTonProcessed: 23.9,
    costPerCarat: 52.1,
    
    kpis: {
      fuelConsumptionPerHour: { value: 41.8, unit: 'L/h', vsBudget: 1.8, vsLY: -1.6 },
      materialsPerTonProcessed: { value: 23.9, unit: 'USD/t', vsBudget: 3.5, vsLY: -1.2 },
      consumablesPerCarat: { value: 52.1, unit: 'USD/ct', vsBudget: 2.8, vsLY: -1.1 },
      avgUnitPrice: { value: 2.72, unit: 'USD/L', vsBudget: 2.1, vsLY: -4.6 },
      top5MaterialsShare: { value: 77.2, unit: '%', vsBudget: -0.5, vsLY: -1.3 },
    },
    
    byCategory: [
      { category: { pt: 'Gasóleo', en: 'Diesel' }, value: 19.8, percentage: 30.6, yoyChange: 7.0, vsBudget: 2.5, unitCost: 2.72, consumption: 7280000 },
      { category: { pt: 'Stock Consignado - Peças Cimertex', en: 'Consigned Stock - Cimertex Parts' }, value: 11.2, percentage: 17.3, yoyChange: 12.5, vsBudget: 4.2, unitCost: null, consumption: null },
      { category: { pt: 'Conservação e Reparação', en: 'Conservation & Repair' }, value: 8.5, percentage: 13.2, yoyChange: 8.2, vsBudget: 3.1, unitCost: null, consumption: null },
      { category: { pt: 'Explosivos', en: 'Explosives' }, value: 7.8, percentage: 12.1, yoyChange: 16.4, vsBudget: 5.2, unitCost: 4.35, consumption: 1790000 },
      { category: { pt: 'Pneus', en: 'Tires' }, value: 5.2, percentage: 8.0, yoyChange: 5.1, vsBudget: 1.2, unitCost: 12800, consumption: 406 },
      { category: { pt: 'Lubrificantes e Outros Fluídos', en: 'Lubricants & Other Fluids' }, value: 4.8, percentage: 7.4, yoyChange: 11.1, vsBudget: 2.8, unitCost: 8.80, consumption: 545000 },
      { category: { pt: 'DMS Ferro Silício', en: 'DMS Ferrosilicon' }, value: 3.2, percentage: 5.0, yoyChange: 18.5, vsBudget: 6.5, unitCost: 1.85, consumption: 1730000 },
      { category: { pt: 'Material Protecção, Seg. e Conforto', en: 'PPE, Safety & Comfort' }, value: 2.4, percentage: 3.7, yoyChange: 4.3, vsBudget: -1.2, unitCost: null, consumption: null },
      { category: { pt: 'Ferrament. e Utensílios Desg. Rápido', en: 'Tools & Fast-Wear Items' }, value: 1.7, percentage: 2.6, yoyChange: 6.2, vsBudget: 0.8, unitCost: null, consumption: null },
    ],
    
    monthlyData: [
      { month: 'Jan', cost: 5.0, budget: 4.8, volume: 220, unitCost: 22.7 },
      { month: 'Feb', cost: 5.1, budget: 4.9, volume: 225, unitCost: 22.7 },
      { month: 'Mar', cost: 5.5, budget: 5.2, volume: 240, unitCost: 22.9 },
      { month: 'Apr', cost: 5.3, budget: 5.0, volume: 232, unitCost: 22.8 },
      { month: 'May', cost: 5.2, budget: 5.0, volume: 228, unitCost: 22.8 },
      { month: 'Jun', cost: 5.6, budget: 5.3, volume: 248, unitCost: 22.6 },
      { month: 'Jul', cost: 5.4, budget: 5.1, volume: 238, unitCost: 22.7 },
      { month: 'Aug', cost: 5.3, budget: 5.0, volume: 232, unitCost: 22.8 },
      { month: 'Sep', cost: 5.2, budget: 5.0, volume: 228, unitCost: 22.8 },
      { month: 'Oct', cost: 5.5, budget: 5.2, volume: 242, unitCost: 22.7 },
      { month: 'Nov', cost: 5.4, budget: 5.1, volume: 235, unitCost: 23.0 },
      { month: 'Dec', cost: 5.9, budget: 5.4, volume: 232, unitCost: 25.4 },
    ],
    
    priceVolumeAnalysis: {
      baselineCost: 58.0,
      volumeEffect: { value: 4.8, description: { pt: '+12.5% maior throughput', en: '+12.5% higher throughput' } },
      priceEffect: { value: 1.8, description: { pt: 'Estabilização preços', en: 'Price stabilization' } },
      currentCost: 64.6,
    },
    
    unitConsumption: [
      { activity: { pt: 'Escavação', en: 'Excavation' }, unit: 'L/m³', current: 0.82, budget: 0.80, ly: 0.85, trend: 'down' },
      { activity: { pt: 'Transporte', en: 'Hauling' }, unit: 'L/t.km', current: 0.050, budget: 0.048, ly: 0.052, trend: 'down' },
      { activity: { pt: 'Processamento', en: 'Processing' }, unit: 'kg/t', current: 2.08, budget: 2.05, ly: 2.15, trend: 'down' },
      { activity: { pt: 'Perfuração', en: 'Drilling' }, unit: 'L/m', current: 3.10, budget: 3.05, ly: 3.20, trend: 'down' },
    ],
    
    monthlyUnitConsumption: [
      { month: 'Jan', fuel: 0.83, explosives: 1.06, reagents: 2.08, lubricants: 0.18 },
      { month: 'Feb', fuel: 0.82, explosives: 1.05, reagents: 2.07, lubricants: 0.18 },
      { month: 'Mar', fuel: 0.82, explosives: 1.05, reagents: 2.08, lubricants: 0.18 },
      { month: 'Apr', fuel: 0.81, explosives: 1.04, reagents: 2.06, lubricants: 0.17 },
      { month: 'May', fuel: 0.81, explosives: 1.04, reagents: 2.06, lubricants: 0.17 },
      { month: 'Jun', fuel: 0.80, explosives: 1.03, reagents: 2.05, lubricants: 0.17 },
      { month: 'Jul', fuel: 0.81, explosives: 1.04, reagents: 2.06, lubricants: 0.17 },
      { month: 'Aug', fuel: 0.82, explosives: 1.05, reagents: 2.07, lubricants: 0.18 },
      { month: 'Sep', fuel: 0.82, explosives: 1.05, reagents: 2.07, lubricants: 0.18 },
      { month: 'Oct', fuel: 0.82, explosives: 1.05, reagents: 2.08, lubricants: 0.18 },
      { month: 'Nov', fuel: 0.83, explosives: 1.06, reagents: 2.09, lubricants: 0.18 },
      { month: 'Dec', fuel: 0.85, explosives: 1.08, reagents: 2.12, lubricants: 0.19 },
    ],
    
    priceVolumeWaterfall: [
      { name: { pt: 'Custo 2024', en: 'Cost 2024' }, value: 58.0, type: 'start' },
      { name: { pt: 'Efeito Volume', en: 'Volume Effect' }, value: 4.8, type: 'increase', description: { pt: 'Maior throughput (+12.5%)', en: 'Higher throughput (+12.5%)' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Volume', en: 'Volume Effect Decomposition' },
          metrics: [
            { label: { pt: 'Throughput 2024', en: 'Throughput 2024' }, value: '2.4 Mt', change: null },
            { label: { pt: 'Throughput 2025', en: 'Throughput 2025' }, value: '2.7 Mt', change: '+12.5%' },
            { label: { pt: 'Consumo Adicional', en: 'Additional Consumption' }, value: '+0.3 Mt', change: null },
            { label: { pt: 'Custo Unitário Médio', en: 'Avg Unit Cost' }, value: '16.0 USD/t', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+4.8 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Efeito Preço Combustível', en: 'Fuel Price Effect' }, value: -0.8, type: 'decrease', description: { pt: 'Redução preço diesel', en: 'Diesel price reduction' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Preço Combustível', en: 'Fuel Price Effect Decomposition' },
          metrics: [
            { label: { pt: 'Preço Médio 2024', en: 'Avg Price 2024' }, value: '2.85 USD/L', change: null },
            { label: { pt: 'Preço Médio 2025', en: 'Avg Price 2025' }, value: '2.72 USD/L', change: '-4.6%' },
            { label: { pt: 'Consumo Associado', en: 'Associated Consumption' }, value: '7.28 M L', change: null },
            { label: { pt: 'Variação de Preço', en: 'Price Variation' }, value: '-0.13 USD/L', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '-0.8 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Efeito Preço Outros', en: 'Other Price Effect' }, value: 1.2, type: 'increase', description: { pt: 'Inflação materiais', en: 'Materials inflation' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Preço Outros Materiais', en: 'Other Materials Price Effect Decomposition' },
          metrics: [
            { label: { pt: 'Explosivos: Preço 2024', en: 'Explosives: Price 2024' }, value: '4.20 USD/kg', change: null },
            { label: { pt: 'Explosivos: Preço 2025', en: 'Explosives: Price 2025' }, value: '4.35 USD/kg', change: '+3.6%' },
            { label: { pt: 'Reagentes: Preço 2024', en: 'Reagents: Price 2024' }, value: '3.50 USD/kg', change: null },
            { label: { pt: 'Reagentes: Preço 2025', en: 'Reagents: Price 2025' }, value: '3.65 USD/kg', change: '+4.3%' },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+1.2 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Eficiência Consumo', en: 'Consumption Efficiency' }, value: -1.2, type: 'decrease', description: { pt: 'Renovação frota', en: 'Fleet renewal' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Eficiência', en: 'Efficiency Effect Decomposition' },
          metrics: [
            { label: { pt: 'Consumo Combustível/h 2024', en: 'Fuel Consumption/h 2024' }, value: '42.5 L/h', change: null },
            { label: { pt: 'Consumo Combustível/h 2025', en: 'Fuel Consumption/h 2025' }, value: '41.8 L/h', change: '-1.6%' },
            { label: { pt: 'Equipamentos Renovados', en: 'Renewed Equipment' }, value: '12 unidades', change: null },
            { label: { pt: 'Poupança Unitária', en: 'Unit Savings' }, value: '-0.7 L/h', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '-1.2 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Mix/Qualidade Minério', en: 'Ore Mix/Quality' }, value: 2.6, type: 'increase', description: { pt: 'Maior uso de reagentes por qualidade', en: 'Higher reagent use due to quality' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Mix/Qualidade', en: 'Ore Mix/Quality Effect Decomposition' },
          metrics: [
            { label: { pt: 'Reagentes/ton 2024', en: 'Reagents/ton 2024' }, value: '2.15 kg/t', change: null },
            { label: { pt: 'Reagentes/ton 2025', en: 'Reagents/ton 2025' }, value: '2.08 kg/t', change: '-3.3%' },
            { label: { pt: 'Dureza Média do Minério', en: 'Avg Ore Hardness' }, value: '+8.5%', change: null },
            { label: { pt: 'Teor Médio', en: 'Average Grade' }, value: '0.46 ct/m³', change: '+2.2%' },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+2.6 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Custo 2025', en: 'Cost 2025' }, value: 64.6, type: 'end' },
    ],
    
    keyDrivers: [
      { driver: { pt: 'Throughput da Planta', en: 'Plant Throughput' }, impact: 'high', direction: 'up', detail: { pt: '+12.5% maior throughput aumentou consumo proporcional de reagentes', en: '+12.5% higher throughput proportionally increased reagent consumption' } },
      { driver: { pt: 'Renovação de Frota', en: 'Fleet Renewal' }, impact: 'high', direction: 'down', detail: { pt: 'Novos equipamentos reduziram consumo unitário em 3.5%', en: 'New equipment reduced unit consumption by 3.5%' } },
      { driver: { pt: 'Qualidade do Minério', en: 'Ore Quality' }, impact: 'medium', direction: 'up', detail: { pt: 'Variação no blend aumentou consumo de reagentes por tonelada', en: 'Blend variation increased reagent consumption per ton' } },
      { driver: { pt: 'Estabilização de Preços', en: 'Price Stabilization' }, impact: 'medium', direction: 'down', detail: { pt: 'Preços de combustível estabilizaram após pico de 2024', en: 'Fuel prices stabilized after 2024 peak' } },
    ],
    
    // Interactive Materials Driver Tree - Hierarchical Model
    materialsDriverTree: {
      root: { 
        name: { pt: 'Materiais Consumidos', en: 'Materials Consumed' }, 
        value: 64.6, 
        unit: 'M USD',
        yoyChange: 11.4,
        vsBudget: 3.5,
        budgetValue: 62.4
      },
      // 4 Aggregator blocks
      aggregators: [
        {
          id: 'energy-fluids',
          name: { pt: 'Energia e Fluidos', en: 'Energy & Fluids' },
          color: '#EF4444',
          icon: 'fuel',
          vsBudget: 2.8,
          children: [
            {
              id: 'diesel',
              name: { pt: 'Gasóleo', en: 'Diesel' },
              value: 19.8,
              unit: 'M USD',
              percentage: 30.6,
              yoyChange: 7.0,
              vsBudget: 2.5,
              budgetValue: 19.3,
              color: '#EF4444',
              icon: 'fuel',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '2.72', unit: 'USD/L', yoyChange: -4.6, vsBudget: -2.1 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '7.28', unit: 'M Litros', yoyChange: 12.0, vsBudget: 4.8 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '41.8', unit: 'L/hora', yoyChange: -1.6, vsBudget: 1.8 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Escavação e Transporte', en: 'Excavation and Hauling' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MIN-001' }
              }
            },
            {
              id: 'lubricants',
              name: { pt: 'Lubrificantes', en: 'Lubricants' },
              value: 4.8,
              unit: 'M USD',
              percentage: 7.4,
              yoyChange: 11.1,
              vsBudget: 2.8,
              budgetValue: 4.67,
              color: '#10B981',
              icon: 'droplet',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '8.80', unit: 'USD/L', yoyChange: 3.5, vsBudget: 1.2 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '545', unit: 'k Litros', yoyChange: 7.2, vsBudget: 1.5 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '0.18', unit: 'L/hora', yoyChange: -2.1, vsBudget: -0.8 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Manutenção de Equipamentos', en: 'Equipment Maintenance' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MNT-003' }
              }
            }
          ]
        },
        {
          id: 'mine-consumables',
          name: { pt: 'Consumíveis de Mina', en: 'Mine Consumables' },
          color: '#DC2626',
          icon: 'bomb',
          vsBudget: 4.2,
          children: [
            {
              id: 'explosives',
              name: { pt: 'Explosivos', en: 'Explosives' },
              value: 7.8,
              unit: 'M USD',
              percentage: 12.1,
              yoyChange: 16.4,
              vsBudget: 5.2,
              budgetValue: 7.41,
              color: '#DC2626',
              icon: 'bomb',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '4.35', unit: 'USD/kg', yoyChange: 3.6, vsBudget: 2.1 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '1.79', unit: 'M kg', yoyChange: 12.4, vsBudget: 3.0 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '1.21', unit: 'kg/m³', yoyChange: -0.8, vsBudget: -1.2 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Perfuração e Desmonte', en: 'Drilling and Blasting' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MIN-002' }
              }
            },
            {
              id: 'tires',
              name: { pt: 'Pneus', en: 'Tires' },
              value: 5.2,
              unit: 'M USD',
              percentage: 8.0,
              yoyChange: 5.1,
              vsBudget: 1.2,
              budgetValue: 5.14,
              color: '#0EA5E9',
              icon: 'circle',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '12.8', unit: 'k USD/un', yoyChange: 2.4, vsBudget: 0.8 },
                volume: { label: { pt: 'Unidades Consumidas', en: 'Units Consumed' }, value: '406', unit: 'unidades', yoyChange: 2.7, vsBudget: 0.4 },
                unitConsumption: { label: { pt: 'Vida Útil Média', en: 'Average Lifespan' }, value: '4,200', unit: 'horas', yoyChange: 5.0, vsBudget: 2.5 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Transporte de Material', en: 'Material Hauling' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-TRP-001' }
              }
            }
          ]
        },
        {
          id: 'maintenance-spares',
          name: { pt: 'Manutenção e Sobressalentes', en: 'Maintenance & Spares' },
          color: '#F59E0B',
          icon: 'wrench',
          vsBudget: 3.8,
          children: [
            {
              id: 'conservation',
              name: { pt: 'Conservação e Reparação', en: 'Conservation & Repair' },
              value: 8.5,
              unit: 'M USD',
              percentage: 13.2,
              yoyChange: 8.2,
              vsBudget: 3.1,
              budgetValue: 8.24,
              color: '#F59E0B',
              icon: 'wrench',
              details: {
                price: { label: { pt: 'Custo Médio/Intervenção', en: 'Avg Cost/Intervention' }, value: '4.2', unit: 'k USD', yoyChange: 3.5, vsBudget: 1.5 },
                volume: { label: { pt: 'Intervenções', en: 'Interventions' }, value: '2,024', unit: 'unidades', yoyChange: 4.5, vsBudget: 1.5 },
                unitConsumption: { label: { pt: 'MTBF', en: 'MTBF' }, value: '285', unit: 'horas', yoyChange: 2.1, vsBudget: -0.5 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Manutenção Preventiva', en: 'Preventive Maintenance' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MNT-002' }
              }
            },
            {
              id: 'cimertex',
              name: { pt: 'Stock Consignado', en: 'Consigned Stock' },
              value: 11.2,
              unit: 'M USD',
              percentage: 17.3,
              yoyChange: 12.5,
              vsBudget: 4.2,
              budgetValue: 10.75,
              color: '#6366F1',
              icon: 'package',
              details: {
                price: { label: { pt: 'Custo Médio', en: 'Average Cost' }, value: '3.2', unit: 'k USD/peça', yoyChange: 5.8, vsBudget: 2.2 },
                volume: { label: { pt: 'Peças Utilizadas', en: 'Parts Used' }, value: '3,500', unit: 'unidades', yoyChange: 6.3, vsBudget: 1.9 },
                unitConsumption: { label: { pt: 'Taxa de Substituição', en: 'Replacement Rate' }, value: '2.1', unit: '%/mês', yoyChange: -0.8, vsBudget: -0.3 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Manutenção Geral', en: 'General Maintenance' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MNT-001' }
              }
            }
          ]
        },
        {
          id: 'plant-others',
          name: { pt: 'Consumíveis de Planta e Outros', en: 'Plant Consumables & Others' },
          color: '#8B5CF6',
          icon: 'flask',
          vsBudget: 3.5,
          children: [
            {
              id: 'ferrosilicon',
              name: { pt: 'DMS Ferro Silício', en: 'DMS Ferrosilicon' },
              value: 3.2,
              unit: 'M USD',
              percentage: 5.0,
              yoyChange: 18.5,
              vsBudget: 6.5,
              budgetValue: 3.0,
              color: '#8B5CF6',
              icon: 'flask',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '1.85', unit: 'USD/kg', yoyChange: 8.2, vsBudget: 3.2 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '1.73', unit: 'M kg', yoyChange: 9.5, vsBudget: 3.1 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '0.64', unit: 'kg/ton', yoyChange: -2.8, vsBudget: -1.5 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Processamento DMS', en: 'DMS Processing' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-PRC-001' }
              }
            },
            {
              id: 'ppe',
              name: { pt: 'Mat. Protecção e Seg.', en: 'PPE & Safety' },
              value: 2.4,
              unit: 'M USD',
              percentage: 3.7,
              yoyChange: 4.3,
              vsBudget: -1.2,
              budgetValue: 2.43,
              color: '#14B8A6',
              icon: 'shield',
              details: {
                price: { label: { pt: 'Custo Médio/Colaborador', en: 'Avg Cost/Employee' }, value: '1.2', unit: 'k USD/ano', yoyChange: 2.1, vsBudget: -0.5 },
                volume: { label: { pt: 'Colaboradores Equipados', en: 'Equipped Employees' }, value: '2,000', unit: 'pessoas', yoyChange: 2.2, vsBudget: -0.7 },
                unitConsumption: { label: { pt: 'Renovação Média', en: 'Avg Renewal' }, value: '3.2', unit: 'kits/ano', yoyChange: -1.5, vsBudget: -0.8 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Todas as Operações', en: 'All Operations' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-SEG-001' }
              }
            },
            {
              id: 'tools',
              name: { pt: 'Ferramentas', en: 'Tools' },
              value: 1.7,
              unit: 'M USD',
              percentage: 2.6,
              yoyChange: 6.2,
              vsBudget: 0.8,
              budgetValue: 1.69,
              color: '#64748B',
              icon: 'tool',
              details: {
                price: { label: { pt: 'Custo Médio', en: 'Average Cost' }, value: '85', unit: 'USD/un', yoyChange: 4.5, vsBudget: 1.2 },
                volume: { label: { pt: 'Unidades Consumidas', en: 'Units Consumed' }, value: '20,000', unit: 'unidades', yoyChange: 1.6, vsBudget: -0.4 },
                unitConsumption: { label: { pt: 'Vida Útil Média', en: 'Average Lifespan' }, value: '45', unit: 'dias', yoyChange: 3.2, vsBudget: 1.5 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Manutenção e Operações', en: 'Maintenance & Operations' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-OPR-001' }
              }
            }
          ]
        }
      ]
    },
  },
  2026: {
    totalCost: 62.0, 
    weightInOpex: 32.0, 
    yoyChange: -4.0, 
    vsBudget: -2.5,
    costPerTonProcessed: 23.5,
    costPerCarat: 49.6,
    
    kpis: {
      fuelConsumptionPerHour: { value: 40.2, unit: 'L/h', vsBudget: -2.5, vsLY: -3.8 },
      materialsPerTonProcessed: { value: 23.5, unit: 'USD/t', vsBudget: -2.5, vsLY: -1.7 },
      consumablesPerCarat: { value: 49.6, unit: 'USD/ct', vsBudget: -3.2, vsLY: -4.8 },
      avgUnitPrice: { value: 2.68, unit: 'USD/L', vsBudget: -1.5, vsLY: -1.5 },
      top5MaterialsShare: { value: 76.8, unit: '%', vsBudget: -1.2, vsLY: -0.5 },
    },
    
    byCategory: [
      { category: { pt: 'Gasóleo', en: 'Diesel' }, value: 18.2, percentage: 29.4, yoyChange: -8.1, vsBudget: -4.2, unitCost: 2.68, consumption: 6790000 },
      { category: { pt: 'Stock Consignado - Peças Cimertex', en: 'Consigned Stock - Cimertex Parts' }, value: 10.5, percentage: 16.9, yoyChange: -6.3, vsBudget: -3.1, unitCost: null, consumption: null },
      { category: { pt: 'Conservação e Reparação', en: 'Conservation & Repair' }, value: 8.2, percentage: 13.2, yoyChange: -3.5, vsBudget: -2.2, unitCost: null, consumption: null },
      { category: { pt: 'Explosivos', en: 'Explosives' }, value: 7.5, percentage: 12.1, yoyChange: -3.8, vsBudget: -1.8, unitCost: 4.28, consumption: 1752000 },
      { category: { pt: 'Pneus', en: 'Tires' }, value: 5.0, percentage: 8.1, yoyChange: -3.8, vsBudget: -1.5, unitCost: 13200, consumption: 379 },
      { category: { pt: 'Lubrificantes e Outros Fluídos', en: 'Lubricants & Other Fluids' }, value: 4.6, percentage: 7.4, yoyChange: -4.2, vsBudget: -2.1, unitCost: 8.65, consumption: 532000 },
      { category: { pt: 'DMS Ferro Silício', en: 'DMS Ferrosilicon' }, value: 3.0, percentage: 4.8, yoyChange: -6.3, vsBudget: -3.5, unitCost: 1.78, consumption: 1685000 },
      { category: { pt: 'Material Protecção, Seg. e Conforto', en: 'PPE, Safety & Comfort' }, value: 2.5, percentage: 4.0, yoyChange: 4.2, vsBudget: 1.2, unitCost: null, consumption: null },
      { category: { pt: 'Ferrament. e Utensílios Desg. Rápido', en: 'Tools & Fast-Wear Items' }, value: 2.5, percentage: 4.0, yoyChange: 47.1, vsBudget: 12.5, unitCost: null, consumption: null },
    ],
    
    monthlyData: [
      { month: 'Jan', cost: 5.0, budget: 5.1, volume: 215, unitCost: 23.3 },
      { month: 'Feb', cost: 5.1, budget: 5.2, volume: 220, unitCost: 23.2 },
      { month: 'Mar', cost: 5.3, budget: 5.4, volume: 235, unitCost: 22.6 },
      { month: 'Apr', cost: 5.2, budget: 5.3, volume: 228, unitCost: 22.8 },
      { month: 'May', cost: 5.1, budget: 5.2, volume: 222, unitCost: 23.0 },
      { month: 'Jun', cost: 5.4, budget: 5.5, volume: 245, unitCost: 22.0 },
      { month: 'Jul', cost: 5.2, budget: 5.3, volume: 235, unitCost: 22.1 },
      { month: 'Aug', cost: 5.1, budget: 5.2, volume: 228, unitCost: 22.4 },
      { month: 'Sep', cost: 5.1, budget: 5.2, volume: 222, unitCost: 23.0 },
      { month: 'Oct', cost: 5.3, budget: 5.4, volume: 232, unitCost: 22.8 },
      { month: 'Nov', cost: 5.2, budget: 5.3, volume: 225, unitCost: 23.1 },
      { month: 'Dec', cost: 5.0, budget: 5.4, volume: 125, unitCost: 40.0 },
    ],
    
    priceVolumeAnalysis: {
      baselineCost: 64.6,
      volumeEffect: { value: -1.5, description: { pt: '-7.4% menor volume processado', en: '-7.4% lower processed volume' } },
      priceEffect: { value: -1.1, description: { pt: 'Continuação de redução preços', en: 'Continued price reduction' } },
      currentCost: 62.0,
    },
    
    unitConsumption: [
      { activity: { pt: 'Escavação', en: 'Excavation' }, unit: 'L/m³', current: 0.78, budget: 0.80, ly: 0.82, trend: 'down' },
      { activity: { pt: 'Transporte', en: 'Hauling' }, unit: 'L/t.km', current: 0.048, budget: 0.050, ly: 0.050, trend: 'down' },
      { activity: { pt: 'Processamento', en: 'Processing' }, unit: 'kg/t', current: 2.02, budget: 2.05, ly: 2.08, trend: 'down' },
      { activity: { pt: 'Perfuração', en: 'Drilling' }, unit: 'L/m', current: 3.02, budget: 3.05, ly: 3.10, trend: 'down' },
    ],
    
    monthlyUnitConsumption: [
      { month: 'Jan', fuel: 0.80, explosives: 1.04, reagents: 2.04, lubricants: 0.17 },
      { month: 'Feb', fuel: 0.79, explosives: 1.03, reagents: 2.03, lubricants: 0.17 },
      { month: 'Mar', fuel: 0.78, explosives: 1.02, reagents: 2.02, lubricants: 0.17 },
      { month: 'Apr', fuel: 0.78, explosives: 1.02, reagents: 2.02, lubricants: 0.17 },
      { month: 'May', fuel: 0.78, explosives: 1.02, reagents: 2.02, lubricants: 0.17 },
      { month: 'Jun', fuel: 0.77, explosives: 1.01, reagents: 2.01, lubricants: 0.16 },
      { month: 'Jul', fuel: 0.78, explosives: 1.02, reagents: 2.02, lubricants: 0.17 },
      { month: 'Aug', fuel: 0.78, explosives: 1.02, reagents: 2.02, lubricants: 0.17 },
      { month: 'Sep', fuel: 0.78, explosives: 1.02, reagents: 2.02, lubricants: 0.17 },
      { month: 'Oct', fuel: 0.78, explosives: 1.02, reagents: 2.02, lubricants: 0.17 },
      { month: 'Nov', fuel: 0.79, explosives: 1.03, reagents: 2.03, lubricants: 0.17 },
      { month: 'Dec', fuel: 0.82, explosives: 1.05, reagents: 2.05, lubricants: 0.18 },
    ],
    
    priceVolumeWaterfall: [
      { name: { pt: 'Custo 2025', en: 'Cost 2025' }, value: 64.6, type: 'start' },
      { name: { pt: 'Efeito Volume', en: 'Volume Effect' }, value: -1.5, type: 'decrease', description: { pt: 'Menor volume processado', en: 'Lower processed volume' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Volume', en: 'Volume Effect Decomposition' },
          metrics: [
            { label: { pt: 'Throughput 2025', en: 'Throughput 2025' }, value: '2.7 Mt', change: null },
            { label: { pt: 'Throughput 2026', en: 'Throughput 2026' }, value: '2.5 Mt', change: '-7.4%' },
            { label: { pt: 'Redução de Volume', en: 'Volume Reduction' }, value: '-0.2 Mt', change: null },
            { label: { pt: 'Custo Unitário Médio', en: 'Avg Unit Cost' }, value: '7.5 USD/t', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '-1.5 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Efeito Preço Combustível', en: 'Fuel Price Effect' }, value: -0.3, type: 'decrease', description: { pt: 'Estabilização preços', en: 'Price stabilization' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Preço Combustível', en: 'Fuel Price Effect Decomposition' },
          metrics: [
            { label: { pt: 'Preço Médio 2025', en: 'Avg Price 2025' }, value: '2.72 USD/L', change: null },
            { label: { pt: 'Preço Médio 2026', en: 'Avg Price 2026' }, value: '2.68 USD/L', change: '-1.5%' },
            { label: { pt: 'Consumo Associado', en: 'Associated Consumption' }, value: '6.79 M L', change: null },
            { label: { pt: 'Variação de Preço', en: 'Price Variation' }, value: '-0.04 USD/L', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '-0.3 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Eficiência Operacional', en: 'Operational Efficiency' }, value: -1.8, type: 'decrease', description: { pt: 'Melhoria consumo unitário', en: 'Unit consumption improvement' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Eficiência Operacional', en: 'Operational Efficiency Effect Decomposition' },
          metrics: [
            { label: { pt: 'Consumo Combustível/h 2025', en: 'Fuel Consumption/h 2025' }, value: '41.8 L/h', change: null },
            { label: { pt: 'Consumo Combustível/h 2026', en: 'Fuel Consumption/h 2026' }, value: '40.2 L/h', change: '-3.8%' },
            { label: { pt: 'Iniciativas de Eficiência', en: 'Efficiency Initiatives' }, value: '15 implementadas', change: null },
            { label: { pt: 'Poupança Unitária', en: 'Unit Savings' }, value: '-1.6 L/h', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '-1.8 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Mix/Qualidade Minério', en: 'Ore Mix/Quality' }, value: 0.5, type: 'increase', description: { pt: 'Ajuste blend', en: 'Blend adjustment' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Mix/Qualidade', en: 'Ore Mix/Quality Effect Decomposition' },
          metrics: [
            { label: { pt: 'Dureza Média 2025', en: 'Avg Hardness 2025' }, value: '7.2 Mohs', change: null },
            { label: { pt: 'Dureza Média 2026', en: 'Avg Hardness 2026' }, value: '7.5 Mohs', change: '+4.2%' },
            { label: { pt: 'Reagentes/ton 2026', en: 'Reagents/ton 2026' }, value: '2.02 kg/t', change: null },
            { label: { pt: 'Consumo Adicional', en: 'Additional Consumption' }, value: '+85 t reagentes', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+0.5 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Manutenção Preventiva', en: 'Preventive Maintenance' }, value: 0.5, type: 'increase', description: { pt: 'Maior custo peças', en: 'Higher spare parts cost' },
        decomposition: {
          title: { pt: 'Decomposição do Efeito Manutenção', en: 'Maintenance Effect Decomposition' },
          metrics: [
            { label: { pt: 'Custo Peças 2025', en: 'Parts Cost 2025' }, value: '7.2 M USD', change: null },
            { label: { pt: 'Custo Peças 2026', en: 'Parts Cost 2026' }, value: '6.8 M USD', change: '-5.6%' },
            { label: { pt: 'Manutenções Programadas', en: 'Scheduled Maintenances' }, value: '+12 eventos', change: null },
            { label: { pt: 'Custo Unitário', en: 'Unit Cost' }, value: '42 USD/peça', change: null },
            { label: { pt: 'Impacto Absoluto', en: 'Absolute Impact' }, value: '+0.5 M USD', change: null, highlight: true },
          ]
        }
      },
      { name: { pt: 'Custo 2026', en: 'Cost 2026' }, value: 62.0, type: 'end' },
    ],
    
    keyDrivers: [
      { driver: { pt: 'Eficiência Operacional', en: 'Operational Efficiency' }, impact: 'high', direction: 'down', detail: { pt: 'Melhoria contínua nos consumos unitários (-3.5% em média)', en: 'Continuous improvement in unit consumption (-3.5% average)' } },
      { driver: { pt: 'Menor Volume', en: 'Lower Volume' }, impact: 'medium', direction: 'down', detail: { pt: 'Redução de 7.4% no volume processado reduziu consumo total', en: '7.4% reduction in processed volume reduced total consumption' } },
      { driver: { pt: 'Qualidade do Minério', en: 'Ore Quality' }, impact: 'low', direction: 'up', detail: { pt: 'Melhoria na recuperação compensou maior dureza', en: 'Recovery improvement offset higher hardness' } },
      { driver: { pt: 'Gestão de Inventário', en: 'Inventory Management' }, impact: 'medium', direction: 'down', detail: { pt: 'Melhor negociação com fornecedores e gestão de stocks', en: 'Better supplier negotiation and stock management' } },
    ],
    
    materialsDriverTree: {
      root: { 
        name: { pt: 'Materiais Consumidos', en: 'Materials Consumed' }, 
        value: 62.0, 
        unit: 'M USD',
        yoyChange: -4.0,
        vsBudget: -2.5,
        budgetValue: 63.6
      },
      aggregators: [
        {
          id: 'energy-fluids',
          name: { pt: 'Energia e Fluidos', en: 'Energy & Fluids' },
          color: '#3B82F6',
          icon: 'fuel',
          vsBudget: -3.2,
          children: [
            {
              id: 'diesel',
              name: { pt: 'Gasóleo', en: 'Diesel' },
              value: 18.2,
              unit: 'M USD',
              percentage: 29.4,
              yoyChange: -8.1,
              vsBudget: -4.2,
              budgetValue: 19.0,
              color: '#3B82F6',
              icon: 'fuel',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '2.68', unit: 'USD/L', yoyChange: -1.5, vsBudget: -1.2 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '6.79', unit: 'M Litros', yoyChange: -6.7, vsBudget: -3.1 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '40.2', unit: 'L/hora', yoyChange: -3.8, vsBudget: -2.5 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Escavação e Transporte', en: 'Excavation and Hauling' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MIN-001' }
              }
            },
            {
              id: 'lubricants',
              name: { pt: 'Lubrificantes e Outros Fluídos', en: 'Lubricants & Other Fluids' },
              value: 4.6,
              unit: 'M USD',
              percentage: 7.4,
              yoyChange: -4.2,
              vsBudget: -2.1,
              budgetValue: 4.7,
              color: '#10B981',
              icon: 'droplet',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '8.65', unit: 'USD/L', yoyChange: -1.7, vsBudget: -0.8 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '532', unit: 'k Litros', yoyChange: -2.5, vsBudget: -1.3 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '0.17', unit: 'L/hora', yoyChange: -5.6, vsBudget: -3.2 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Manutenção de Equipamentos', en: 'Equipment Maintenance' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MNT-003' }
              }
            }
          ]
        },
        {
          id: 'mine-consumables',
          name: { pt: 'Consumíveis de Mina', en: 'Mine Consumables' },
          color: '#EF4444',
          icon: 'bomb',
          vsBudget: -1.6,
          children: [
            {
              id: 'explosives',
              name: { pt: 'Explosivos', en: 'Explosives' },
              value: 7.5,
              unit: 'M USD',
              percentage: 12.1,
              yoyChange: -3.8,
              vsBudget: -1.8,
              budgetValue: 7.6,
              color: '#EF4444',
              icon: 'bomb',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '4.28', unit: 'USD/kg', yoyChange: -1.6, vsBudget: -0.8 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '1.75', unit: 'M kg', yoyChange: -2.2, vsBudget: -1.0 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '1.18', unit: 'kg/m³', yoyChange: -2.5, vsBudget: -1.5 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Perfuração e Desmonte', en: 'Drilling and Blasting' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MIN-002' }
              }
            },
            {
              id: 'tires',
              name: { pt: 'Pneus', en: 'Tires' },
              value: 5.0,
              unit: 'M USD',
              percentage: 8.1,
              yoyChange: -3.8,
              vsBudget: -1.5,
              budgetValue: 5.1,
              color: '#0EA5E9',
              icon: 'circle',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '13.2', unit: 'k USD/un', yoyChange: 0.0, vsBudget: -0.5 },
                volume: { label: { pt: 'Unidades Consumidas', en: 'Units Consumed' }, value: '379', unit: 'unidades', yoyChange: -3.8, vsBudget: -1.0 },
                unitConsumption: { label: { pt: 'Vida Útil Média', en: 'Average Lifespan' }, value: '4,400', unit: 'horas', yoyChange: 4.8, vsBudget: 2.0 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Transporte de Material', en: 'Material Hauling' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-TRP-001' }
              }
            }
          ]
        },
        {
          id: 'maintenance-spares',
          name: { pt: 'Manutenção e Sobressalentes', en: 'Maintenance & Spares' },
          color: '#F59E0B',
          icon: 'wrench',
          vsBudget: -2.6,
          children: [
            {
              id: 'conservation',
              name: { pt: 'Conservação e Reparação', en: 'Conservation & Repair' },
              value: 8.2,
              unit: 'M USD',
              percentage: 13.2,
              yoyChange: -3.5,
              vsBudget: -2.2,
              budgetValue: 8.4,
              color: '#F59E0B',
              icon: 'wrench',
              details: {
                price: { label: { pt: 'Custo Médio/Intervenção', en: 'Avg Cost/Intervention' }, value: '4.1', unit: 'k USD', yoyChange: -2.4, vsBudget: -1.0 },
                volume: { label: { pt: 'Intervenções', en: 'Interventions' }, value: '2,000', unit: 'unidades', yoyChange: -1.2, vsBudget: -1.2 },
                unitConsumption: { label: { pt: 'MTBF', en: 'MTBF' }, value: '295', unit: 'horas', yoyChange: 3.5, vsBudget: 1.5 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Manutenção Preventiva', en: 'Preventive Maintenance' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MNT-002' }
              }
            },
            {
              id: 'cimertex',
              name: { pt: 'Stock Consignado', en: 'Consigned Stock' },
              value: 10.5,
              unit: 'M USD',
              percentage: 16.9,
              yoyChange: -6.3,
              vsBudget: -3.1,
              budgetValue: 10.8,
              color: '#6366F1',
              icon: 'package',
              details: {
                price: { label: { pt: 'Custo Médio', en: 'Average Cost' }, value: '3.1', unit: 'k USD/peça', yoyChange: -3.1, vsBudget: -1.5 },
                volume: { label: { pt: 'Peças Utilizadas', en: 'Parts Used' }, value: '3,387', unit: 'unidades', yoyChange: -3.2, vsBudget: -1.6 },
                unitConsumption: { label: { pt: 'Taxa de Substituição', en: 'Replacement Rate' }, value: '2.0', unit: '%/mês', yoyChange: -4.8, vsBudget: -2.0 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Manutenção Geral', en: 'General Maintenance' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-MNT-001' }
              }
            }
          ]
        },
        {
          id: 'plant-consumables',
          name: { pt: 'Consumíveis de Planta e Outros', en: 'Plant Consumables & Others' },
          color: '#8B5CF6',
          icon: 'flask',
          vsBudget: -1.2,
          children: [
            {
              id: 'dms-ferrosilicon',
              name: { pt: 'DMS Ferro Silício', en: 'DMS Ferrosilicon' },
              value: 3.0,
              unit: 'M USD',
              percentage: 4.8,
              yoyChange: -6.3,
              vsBudget: -3.5,
              budgetValue: 3.1,
              color: '#8B5CF6',
              icon: 'flask',
              details: {
                price: { label: { pt: 'Preço Médio', en: 'Average Price' }, value: '1.78', unit: 'USD/kg', yoyChange: -2.2, vsBudget: -1.5 },
                volume: { label: { pt: 'Volume Consumido', en: 'Volume Consumed' }, value: '1.69', unit: 'M kg', yoyChange: -4.2, vsBudget: -2.0 },
                unitConsumption: { label: { pt: 'Consumo Unitário', en: 'Unit Consumption' }, value: '0.68', unit: 'kg/t', yoyChange: -3.4, vsBudget: -1.8 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Processamento de Minério', en: 'Ore Processing' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-PLT-001' }
              }
            },
            {
              id: 'ppe-safety',
              name: { pt: 'Material Protecção, Seg. e Conforto', en: 'PPE, Safety & Comfort' },
              value: 2.5,
              unit: 'M USD',
              percentage: 4.0,
              yoyChange: 4.2,
              vsBudget: 1.2,
              budgetValue: 2.47,
              color: '#14B8A6',
              icon: 'shield',
              details: {
                price: { label: { pt: 'Custo Médio', en: 'Average Cost' }, value: '45', unit: 'USD/kit', yoyChange: 2.3, vsBudget: 0.8 },
                volume: { label: { pt: 'Kits Distribuídos', en: 'Kits Distributed' }, value: '55,556', unit: 'unidades', yoyChange: 1.8, vsBudget: 0.4 },
                unitConsumption: { label: { pt: 'Kits/Funcionário', en: 'Kits/Employee' }, value: '4.2', unit: 'un/ano', yoyChange: 0.0, vsBudget: 0.0 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Segurança e Higiene', en: 'Safety & Hygiene' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-SHE-001' }
              }
            },
            {
              id: 'tools-fastWear',
              name: { pt: 'Ferrament. e Utensílios Desg. Rápido', en: 'Tools & Fast-Wear Items' },
              value: 2.5,
              unit: 'M USD',
              percentage: 4.0,
              yoyChange: 47.1,
              vsBudget: 12.5,
              budgetValue: 2.22,
              color: '#64748B',
              icon: 'tool',
              details: {
                price: { label: { pt: 'Custo Médio', en: 'Average Cost' }, value: '125', unit: 'USD/un', yoyChange: 8.7, vsBudget: 3.5 },
                volume: { label: { pt: 'Unidades', en: 'Units' }, value: '20,000', unit: 'unidades', yoyChange: 35.1, vsBudget: 8.7 },
                unitConsumption: { label: { pt: 'Consumo/Mês', en: 'Consumption/Month' }, value: '1,667', unit: 'un/mês', yoyChange: 35.1, vsBudget: 8.7 },
                operation: { label: { pt: 'Operação Associada', en: 'Associated Operation' }, value: { pt: 'Operações Diversas', en: 'Various Operations' } },
                costCenter: { label: { pt: 'Centro de Custo', en: 'Cost Center' }, value: 'CC-OPS-001' }
              }
            }
          ]
        }
      ]
    },
  },
};
